import { createActions } from 'redux-actions';
import { InsuranceClaimList } from '@models/InsuranceClaim';
import { Pagination } from '@models/Pagination';
import { GetAllClaimParams } from '@apis/InsuranceClaimApi';

export type State = {
  claims?: InsuranceClaimList[] | null;
  pagination?: Pagination;
  isLoading: boolean;
};

export type ClaimsFetchPayload = GetAllClaimParams;
export type StateUpdatePayload = Partial<State>;

export const {
  claimsFetch,
  stateUpdate,
} = createActions(
  'CLAIMS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_CLAIM_LIST_PAGE',
  },
);
